const firebaseConfig = {
    apiKey: "AIzaSyCpeGlwIfPrY0Dy0n1xLjkjy4r-VQ07W2M",
    authDomain: "universal-dental-clinic.firebaseapp.com",
    projectId: "universal-dental-clinic",
    storageBucket: "universal-dental-clinic.appspot.com",
    messagingSenderId: "794023144942",
    appId: "1:794023144942:web:f6e9362a84e94e7d40f2ff"
  };

  export default firebaseConfig;